import { api } from "@/comn";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TGridSchema, TFormSchema } from "@/comn/hooks";

/*
 * Common Popup
 * !== 공통 팝업 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/comn`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/ppup`,
    nodes: [],
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getPostCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/post-cd?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getComnCdMLst: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/comn-cd-m?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getComnCdDLst: (data: any) => {
        return api.get(`${BASE.api}/comn-cd-d`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getOrgDept: (data: any) => {
        return api.get(`${BASE.api}/org-dept`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getUsrLst: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/usr?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getUsrByOrgRoleLst: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/usr/by-org-role?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getOgaHsCdLst: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/oga-hs-cds?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getSpfcCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/spfc-cd?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getOfcrSpfcCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/ofcr-spfc-cd?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

export const SF_POST_CD_SRCH: TFormSchema = {
    id: "form_postCd",
    schema: {
        regnPostCd: {
            type: "code",
            area: "regnPostCd",
            label: "L_REGN_POST_CD",
            // required: true,
        },
        dstrPostCd: {
            type: "code",
            area: "dstrPostCd",
            label: "L_DSTR_POST_CD",
            // required: true,
        },
        wardPostCd: {
            type: "code",
            area: "wardPostCd",
            label: "L_WARD_POST_CD",
            // required: true,
        },
    },
};

export const SG_POST_CD: TGridSchema = {
    id: "grid_postCd",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_REGN_POST_CD", binding: "regnPostCd", width: 100 }] },
        { cells: [{ header: "L_REGN_POST_NM", binding: "regnPostNm", width: "*" }] },
        { cells: [{ header: "L_DSTR_POST_CD", binding: "dstrPostCd", width: 100 }] },
        { cells: [{ header: "L_DSTR_POST_NM", binding: "dstrPostNm", width: "*" }] },
        { cells: [{ header: "L_WARD_POST_CD", binding: "wardPostCd", width: 100 }] },
        { cells: [{ header: "L_WARD_POST_NM", binding: "wardPostNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "regnPostCd" }],
        },
        {
            cells: [{ binding: "regnPostNm" }],
        },
        {
            cells: [{ binding: "dstrPostCd" }],
        },
        {
            cells: [{ binding: "dstrPostNm" }],
        },
        {
            cells: [{ binding: "wardPostCd" }],
        },
        {
            cells: [{ binding: "wardPostNm" }],
        },
    ],
};

/**
 * Common Code Master Popup
 */
export const SF_COMN_CD_M_SRCH: TFormSchema = {
    id: "form_comnCdM",
    schema: {
        comnCd: {
            type: "text",
            label: "L_COMN_CD",
        },
        bsopClsfCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0088",
            label: "L_TASK_TP",
        },
        comnCdNm: {
            type: "text",
            label: "L_COMN_CD_NM",
        },
    },
};

export const SG_COMN_CD_M: TGridSchema = {
    id: "grid_comnCdM",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_TASK_TP", binding: "bsopClsfCd", width: 100 }] },
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: 150 }] },
        { cells: [{ header: "L_COMN_CD_NM", binding: "comnCdNm", width: "*" }] },
        { cells: [{ header: "L_CD_VLD_VAL", binding: "comnCdVld", width: 130 }] },
    ],
    body: [
        {
            cells: [{ binding: "bsopClsfCd" }],
        },
        {
            cells: [{ binding: "comnCd" }],
        },
        {
            cells: [{ binding: "comnCdNm", align: "left" }],
        },
        { cells: [{ binding: "comnCdVld", align: "center" }] },
    ],
};

export const SF_COMN_CD_D: TFormSchema = {
    id: "form_comnCdD",
    schema: {
        comnCd: {
            type: "text",
            label: "L_COMN_CD",
            edit: false,
        },
        bsopClsfCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0088",
            label: "L_TASK_TP",
            edit: false,
        },
        comnCdNm: {
            type: "text",
            label: "L_COMN_CD_NM",
            edit: false,
        },
    },
};

// Common Code Management Valid Values List Grid Schema !== 공통 코드 관리 유효 값 목록 그리드 스키마 ==!
export const SG_COMN_CD_D: TGridSchema = {
    id: "grid_comnCdD",
    options: { index: true },
    head: [
        { cells: [{ header: "L_CD_VLD_VAL", binding: "cdVldVal", width: "20%" }] },
        { cells: [{ header: "L_CD_VLD_VAL_NM", binding: "cdVldValNm", width: "80%" }] },
    ],
    body: [
        { cells: [{ binding: "cdVldVal", edit: false, align: "center" }] },
        { cells: [{ binding: "cdVldValNm", edit: false, align: "left" }] },
    ],
};

/**
 * Organization Department Popup
 */
export const SF_ORG_DEPT_M_SRCH: TFormSchema = {
    id: "form_orgDeptMSrch",
    schema: {
        orgNm: {
            type: "text",
            label: "L_ORG_NM",
            maxLength: 300,
            edit: false,
        },
        deptNm: {
            type: "text",
            label: "L_DEPT_NM",
            maxLength: 300,
        },
    },
};

export const SG_ORG_DEPT_M: TGridSchema = {
    id: "grid_orgDeptM",
    options: { pagination: false, edit: false, index: true },
    head: [
        // { cells: [{ header: "L_DEPT_CD", binding: "deptCd", width: 150 }] },
        { cells: [{ header: "L_DEPT_NM", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_DEPT_DESC", binding: "deptDesc", width: "*" }] },
    ],
    body: [
        // {
        //     cells: [{ binding: "deptCd", align: "center" }],
        // },
        {
            cells: [{ binding: "deptNm", align: "left" }],
        },
        {
            cells: [{ binding: "deptDesc", align: "left" }],
        },
    ],
};

/**
 * User Popup by TIN
 */
export const SF_USR_M_SRCH: TFormSchema = {
    id: "form_usrMSrch",
    schema: {
        userName: {
            type: "text",
            label: "L_USER_NM",
            maxLength: 300,
        },
    },
};

export const SG_USR_M_LIST: TGridSchema = {
    id: "grid_usrList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USER_NM", binding: "userName", width: 300 }] },
        { cells: [{ header: "L_ROLE_ID", binding: "roles", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "userName", align: "left" }],
        },
        {
            cells: [{ binding: "roles", align: "left" }],
        },
    ],
};

/**
 * User Popup by TIN
 */
export const SF_USR_BY_ROLE_SRCH: TFormSchema = {
    id: "form_usrByRoleSrch",
    schema: {
        srchUserName: {
            type: "text",
            label: "L_USER_NM",
            maxLength: 300,
        },
    },
};

export const SG_USR_BY_ROLE_LIST: TGridSchema = {
    id: "grid_usrByRoleList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "userId", width: "*" }] },
        { cells: [{ header: "L_USER_NM", binding: "userName", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "userId", align: "left" }],
        },
        {
            cells: [{ binding: "userName", align: "left" }],
        },
    ],
};

/** OGA HS CODE  */
export const SF_OGA_HS_CD_SRCH: TFormSchema = {
    id: "form_HsCdSrch",
    schema: {
        hsCd: {
            type: "text",
            label: "L_HS",
            area: "hsCd",
            controlSize: 4,
            placeholder: "0000.00.00.0000",
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hsDesc: { type: "text", label: "L_HS_DESC", area: "hsDesc", controlSize: 4 },
        hsDgt: {
            type: "radio",
            area: "comnCd",
            comnCd: "OSC0048",
            excludes: ["0"],
            label: "L_HS_DGT",
            defaultValue: "12",
            controlSize: 10,
        },
    },
};
export const SG_OGA_HS_CD_LST: TGridSchema = {
    id: "grid_ogaHsCdLst",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: "*" }] },
        { cells: [{ header: "L_HS_DESC", binding: "hsDesc", width: "*" }] },
        { cells: [{ header: "L_PUPS", binding: "pupsCd", width: "*" }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: "*" }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "hsCd" }],
        },
        {
            cells: [{ binding: "hsDesc" }],
        },
        {
            cells: [{ binding: "pupsCd" }],
        },
        {
            cells: [{ binding: "appdStrtDt", type: "date" }],
        },
        {
            cells: [{ binding: "appdEndDt", type: "date" }],
        },
    ],
};

/** Additional Item Specific Code Popup !== 추가항목 특정 코드 팝업 ==! */
export const SF_SPFC_CD_SRCH: TFormSchema = {
    id: "form_spfcCdSrch",
    schema: {
        srchSpfcCd: { type: "text", label: "L_SPFC_CD" },
        srchSpfcCdNm: { type: "text", label: "L_SPFC_CD_NM" },
    },
};

export const SG_SPFC_CD_LST: TGridSchema = {
    id: "grid_spfcCdLst",
    options: { pagination: "out", edit: false, index: true, height: 400 },
    head: [
        { cells: [{ header: "L_SPFC_CD", binding: "spfcCd", width: 100 }] },
        { cells: [{ header: "L_SPFC_CD_NM", binding: "spfcCdNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "spfcCd" }] },
        { cells: [{ binding: "spfcCdNm", align: "left" }] },
    ],
};
